import { createFileRoute } from '@tanstack/react-router'
import { ContractingSettingsSection } from '../../../features/projects/contracting/contract-settings-section'
import { requireSection } from '../../../features/settings/guards'

export const Route = createFileRoute('/_app/settings/project-contracting')({
  staticData: { crumb: 'settingsSection' },
  beforeLoad: ({ context }) => requireSection(context.session, 'project-contracting'),
  component: ContractingSettingsSection,
})
